export const GET_PRO_REVIEW_START = 'GET_PRO_REVIEW_START'
export const GET_PRO_REVIEW_END = 'GET_PRO_REVIEW_END'
export const SET_PRO_REVIEW_FILTER = 'SET_PRO_REVIEW_FILTER'
export const SET_PRO_REVIEW_SORTING = 'SET_PRO_REVIEW_SORTING'
export const SET_PRO_REVIEW_MODAL_OPEN = 'SET_PRO_REVIEW_MODAL_OPEN'
export const SET_PRO_REVIEW_MODAL_CLOSE = 'SET_PRO_REVIEW_MODAL_CLOSE'
export const SET_PRO_COMMENT_REVIEWED = 'SET_PRO_COMMENT_REVIEWED'